export const ConditionIcon = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 13.4213H9.33333V10.7817H12V8.14212H9.33333V5.50251H6.66667V8.14212H4V10.7817H6.66667V13.4213ZM8 20C5.69298 19.3772 3.78293 18.0331 2.26987 15.9675C0.756622 13.9019 0 11.5926 0 9.03958V2.96454L8 0L16 2.96454V9.03958C16 11.5926 15.2434 13.9019 13.7301 15.9675C12.2171 18.0331 10.307 19.3772 8 20ZM8 18.331C9.84889 17.7503 11.3778 16.5888 12.5867 14.8467C13.7956 13.1046 14.4 11.1689 14.4 9.03958V4.05073L8 1.68512L1.6 4.05073V9.03958C1.6 11.1689 2.20444 13.1046 3.41333 14.8467C4.62222 16.5888 6.15111 17.7503 8 18.331Z"
        fill="black"
      />
    </svg>
  );
};
